import { getUserAgent, Device, Browser } from "@kakaopay-common/user-agent";
import { canUse, notSupportedResponse } from "../utils/canUse.mjs";
import { generateUuid } from "./generateUuid.mjs";
import { mockInterface } from "./mockInterface.mjs";
var SCRAP_STATUS = /* @__PURE__ */ ((SCRAP_STATUS2) => {
  SCRAP_STATUS2["START"] = "START";
  SCRAP_STATUS2["END"] = "END";
  return SCRAP_STATUS2;
})(SCRAP_STATUS || {});
function isWebviewPluginEnv() {
  var _a, _b;
  return (Browser.isPayWebview() || Browser.isBizWebview()) && (Device.isAndroid() && window.KakaoPayWebViewPlugin || Device.isIos() && ((_b = (_a = window.webkit) == null ? void 0 : _a.messageHandlers) == null ? void 0 : _b.KakaoPayWebViewPlugin));
}
const accountNumberFilterRegex = /"\w*account_num\w*\\*":\\*"(\d*)\\*"/g;
const filterAccountNumber = (data) => {
  const accountNumberFiltered = data.replace(
    accountNumberFilterRegex,
    (match, accountNumber) => {
      return match.replace(accountNumber, "****");
    }
  );
  return accountNumberFiltered;
};
function getLogMessage(parameter) {
  return filterAccountNumber(JSON.stringify(parameter));
}
function initVariable() {
  if (typeof window === "undefined") {
    console.log("[PostMessage.ts] can not be called in the node environment.");
    return { result: false };
  }
  if (!window.KakaoPay) {
    console.log("[PostMessage.ts] window.KakaoPay is not defined.");
    window.KakaoPay = {
      postMessage: () => {
      },
      webViewPluginCallback: () => {
      },
      webNavigationBack: () => {
      },
      webTabSelected: () => {
      },
      callbacks: /* @__PURE__ */ new Map()
    };
  }
  let postMessageFunc;
  if (!isWebviewPluginEnv()) {
    postMessageFunc = (parameter) => {
      var _a;
      window.KakaoPay.webViewPluginCallback({
        success: true,
        command: parameter.command,
        result: mockInterface(parameter.command),
        extras: {
          identifier: (_a = parameter == null ? void 0 : parameter.extras) == null ? void 0 : _a.identifier,
          type: "mock"
        }
      });
    };
  } else {
    if (Device.isAndroid()) {
      postMessageFunc = (parameter) => {
        console.log(
          "[PostMessage.ts] sendCommand to Android : " + getLogMessage(parameter)
        );
        window.KakaoPayWebViewPlugin.postMessage(JSON.stringify(parameter));
      };
    } else {
      postMessageFunc = (parameter) => {
        console.log("[PostMessage.ts] sendCommand to Ios : " + getLogMessage(parameter));
        window.webkit.messageHandlers.KakaoPayWebViewPlugin.postMessage(parameter);
      };
    }
  }
  return { result: true, postMessageFunc };
}
var PostMessage;
((PostMessage2) => {
  console.log("[PostMessage.ts] load. OS : " + JSON.stringify(getUserAgent()));
  const { result, postMessageFunc } = initVariable();
  if (result) {
    if (!window.KakaoPay.callbacks) {
      window.KakaoPay.callbacks = /* @__PURE__ */ new Map();
    }
    window.KakaoPay.webViewPluginCallback = webViewPluginCallback;
  } else {
    console.error("[PostMessage.ts] initVariable failed. it might be window problem.");
  }
  function sendCommand(request, callback) {
    if (typeof window === "undefined") {
      console.warn(
        "[PostMessage.ts] sendCommand can't be called in the node environment."
      );
      return;
    }
    if (Browser.isKakao() && !Browser.isPayWebview() || // 톡/페이앱 웹뷰이지만 통합웹뷰가 아닌 경우
    Browser.isKakaoPayBizApp() && !Browser.isBizWebview()) {
      return callback({
        success: false,
        command: request.command,
        extras: {
          identifier: ""
        },
        error: {
          code: "NOT_SUPPORTED_WEBVIEW",
          message: "지원하지 않는 웹뷰입니다."
        }
      });
    }
    if (!canUse({
      command: request.command,
      minVersion: request.version,
      userAgent: window.navigator.userAgent
    })) {
      return callback(notSupportedResponse(request.command));
    }
    const uuid = generateUuid();
    window.KakaoPay.callbacks.set(uuid, callback);
    const parameter = {
      ...request,
      extras: {
        ...request.extras,
        identifier: uuid
      }
    };
    if (postMessageFunc) {
      postMessageFunc(parameter);
    } else {
      console.warn("[PostMessage.ts] postMessageFunc is not defined.");
    }
  }
  PostMessage2.sendCommand = sendCommand;
  function webViewPluginCallback(response) {
    var _a, _b, _c, _d;
    console.log(
      "[PostMessage.ts] client responded.",
      JSON.stringify(response, (key, value) => {
        if (key === "image_data") {
          return "data";
        }
        return value;
      })
    );
    if (response.command === "scrap_status") {
      console.log(
        "[PostMessage.ts] scrap_status responsed with " + ((_a = response.result) == null ? void 0 : _a.status)
      );
      if (response.success) {
        const event = new CustomEvent(response.command, {
          detail: (_b = response.result) == null ? void 0 : _b.status
        });
        document.dispatchEvent(event);
      }
      return;
    }
    if (response.command === "show_navigation_icon") {
      console.log(
        "[PostMessage.ts] show_navigation_icon responsed with " + JSON.stringify(response.result)
      );
      if (response.success && ((_c = response.result) == null ? void 0 : _c.is_clicked)) {
        const event = new CustomEvent(response.command, {
          detail: (_d = response.result) == null ? void 0 : _d.icon_name
        });
        document.dispatchEvent(event);
        return;
      }
    }
    if (!response.extras) {
      throw new Error("[PostMessage.ts] There is no extras field on response.");
    }
    if (window.KakaoPay.callbacks.has(response.extras.identifier)) {
      const callback = window.KakaoPay.callbacks.get(response.extras.identifier);
      if (callback) {
        callback(response);
      } else {
        console.warn(
          "[PostMessage.ts] callback is undefined. id - " + response.extras.identifier
        );
      }
      window.KakaoPay.callbacks.delete(response.extras.identifier);
    } else {
      console.error(
        "[PostMessage.ts]" + response.extras.identifier + " has no callback function."
      );
    }
  }
  PostMessage2.webViewPluginCallback = webViewPluginCallback;
})(PostMessage || (PostMessage = {}));
const PostMessage$1 = PostMessage;
export {
  SCRAP_STATUS,
  PostMessage$1 as default,
  filterAccountNumber
};
